module.exports = __webpack_public_path__ + "static/media/rank.e8141628.png";